var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-secondary-nav" },
    [
      _vm._l(_vm.navItems, function(item, index) {
        return [
          item.externalLink
            ? _c(
                "a",
                {
                  key: "c-secondary-nav__" + index,
                  staticClass: "c-secondary-nav__item t-paragraph-large",
                  class: {
                    "l-grid__item--justify-start": index === 0,
                    "l-grid__item--justify-center": index === 1,
                    "l-grid__item--justify-end": index === 2
                  },
                  attrs: {
                    href: item.linkUrl,
                    tabindex: _vm.tabindexStart + index
                  }
                },
                [_vm._v("\n      " + _vm._s(item.linkText) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          !item.externalLink
            ? _c(
                "nuxt-link",
                {
                  key: "c-secondary-nav__" + index,
                  staticClass: "c-secondary-nav__item t-paragraph-large",
                  class: {
                    "l-grid__item--justify-start": index === 0,
                    "l-grid__item--justify-center": index === 1,
                    "l-grid__item--justify-end": index === 2
                  },
                  attrs: {
                    to: item.linkUrl,
                    tabindex: _vm.tabindexStart + index
                  }
                },
                [_vm._v("\n      " + _vm._s(item.linkText) + "\n    ")]
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }